module.exports = __webpack_public_path__ + "assets/7598030238e8f9cfae109d10a7c493de.mp3";